<div class="app-page" style="margin-left: 20px;">



  <button mat-raised-button (click)="editOrgMission()">EDIT</button>
  <div style="display: flex; flex-direction: row; margin-left: 30px;">
    <div style="font-family: Roboto; margin-top: 30px;">
      <img src="assets/img/OKR/mission.png" style="width: 40px;">
      <div>MISSION</div>

    </div>
    @if (this.Mission!=null && this.Mission!='') {
<div  style="display: flex;
            font-family: roboto;
            font-size: large;
            width: 500px;
            align-items: center;
            margin-left: 30px;">
        {{this.Mission}}
      </div>
    }
    @if (this.Mission==null || this.Mission=='') {
      <div STYLE="width: 300px; margin-left: 100px;">
        <div style="font-family: Roboto; color: gray; margin-top: 30px;">
          NO MISSION STATEMENT SET
        </div>
      </div>
    }
  </div>


  <br/>

  <div style="display: flex; flex-direction: row; margin-left: 30px;">
    <div style="font-family: Roboto;">
      <img src="/assets/img/OKR/vision.png" STYLE="width: 50px;">
      <div>VISION</div>
    </div>
    @if (this.Vision!=null && this.Vision!='' ) {
<div style="display: flex;
            font-family: roboto;
            font-size: large;
            width: 380px;
            align-items: center;
            margin-left: 30px;">
        {{this.Vision}}
      </div>
    }
    @if (this.Vision==null || this.Vision=='') {
      <div STYLE="width: 300px; margin-left: 100px;">
        <div style="font-family: Roboto; color: gray; margin-top: 30px;">
          NO VISION STATEMENT SET
        </div>
      </div>
    }
  </div>

  <br/>
  <mat-divider></mat-divider>
  <br/>
  <div style="display: flex;flex-direction: row; align-items: flex-end;">
    <div class="title">OBJECTIVES</div>
    <button mat-button (click)="addObjective('ORGANIZATION')"><mat-icon>add</mat-icon>NEW ORGANIZATION OBJECTIVE</button>
  </div>
  @if (this.objectives.length>0) {
    <app-objectives-current-state [Objectives]="this.objectives"></app-objectives-current-state>
  }


  @for (obj of this.objectives; track obj) {
    <app-objective-player-row [Objective]="obj" (ObjectiveDeletedEvent)="refresh()" (ObjectiveChangedEvent)="refresh()" ></app-objective-player-row>
  }
  @if (this.objectives.length==0) {
    <div style="width: 300px; height: 200px; margin-left: 100px; align-items: center; display: flex;font-family: Roboto; color: gray">
      NO ORGANIZATION LEVEL OBJECTIVES DEFINED
    </div>
  }
  <br/>
</div>
